import { Grid } from "@chakra-ui/react";
import GameItem from "./GameItem";
import getMediaUrl from "../../utilities/getMediaUrl";

import { Box, Image, Text, AspectRatio } from "@chakra-ui/react";
import comingsoon from "../../assets/comingsoon.webp";

function AvailableGames({ games, minW = "240px", onItemHover, isPC }) {
  const mediaTileProps = {
    borderRadius: "16px",
    overflow: "hidden",
    boxShadow: "sm",
    bg: "gray.100",
    transition: "transform 120ms ease, box-shadow 120ms ease",
    /* _hover: { transform: "translateY(-2px)", boxShadow: "md" }, */
  };
  const items = Array.isArray(games) ? games.filter(Boolean) : [];
  
  return (
    <Grid
      templateColumns={{
        base: "repeat(2, 1fr)",
        sm: "repeat(3, 1fr)",
        md: "repeat(4, 1fr)",
        lg: "repeat(5, 1fr)",
        xl: "repeat(6, 1fr)",
      }}
      gap={{ base: 4, md: 5, xl: 6 }}
      w="100%"
      maxW="100%"
      m={0}
      px={{ base: 2, md: 4 }}
      py={{ base: 2, md: 4 }}
      alignItems="stretch"
      justifyItems="stretch"
    >
      {/* Copied from GameItem */}
      {items.length === 0 && (
        <Box>
          <Box {...mediaTileProps} boxShadow='0 4px 8px #4A5568'>
              <Image
                alt={"Coming Soon"}
                src={comingsoon}
                loading="lazy"
                objectFit="cover"
              />
          </Box>

          <Text
            mt={2}
            fontSize="md"
            fontWeight="semibold"
            color="gray.700"
            noOfLines={2}
          >
            Coming Soon!
          </Text>
        </Box>
      )}

      {items.map((game) => {
        const { title, slug, thumbnail, id, ratings, hover_video } = game;
        return (
          <GameItem
            key={id}
            id={id}
            title={title}
            slug={slug}
            rating={ratings}
            thumbnail={getMediaUrl(thumbnail.url)}
            // vidPath={getMediaUrl(hover_video.url)}
            onHover={onItemHover}
            gameData={game}
            isPC={isPC}
          />
        );
      })}
    </Grid>
  );
}

export default AvailableGames;
